import Vue from 'vue'
import axios from 'axios'
import { VueAxios } from './axios'

import qs from 'qs'
// 创建 axios 实例
const service = axios.create({
  // baseURL: 'http://sxgl.sxyyc.net',
  baseURL: process.env.VUE_APP_API_BASE_URL,
  // api base_url
  timeout: 10000, // 请求超时时间
  paramsSerializer: function (params) {
    return qs.stringify(params, { allowDots: true })
  },
  headers: {
    'Pragma': 'no-cache'
  },
})

const err = (error) => {
  if (error.response) {
    const data = error.response.data
    //const token = Vue.ls.get(ACCESS_TOKEN)
    if (error.response.status === 403) {

    }
    if (error.response.status === 401 && !(data.result && data.result.isLogin)) {

      if (token) {

      }
    }
  }
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
  //const token = Vue.ls.get(ACCESS_TOKEN)
  // if (token) {
  // config.headers['Authorization'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  // config[config.method === 'get' ? 'params' : 'data'] = Object.assign(
  //   { token: token },
  //   config[config.method === 'get' ? 'params' : 'data']
  // ) // 请求数据植入token
  // }

  if (config.method !== 'get') {
    config.data = config.data || []
    //config.data['Authorization'] = token
  } else {
    config.params = config.params || []
    //config.params['Authorization'] = token
  }

  if (config.method !== 'get') {
    // config.data = qs.stringify(config.data)
    // config.data = qs.stringify(config.data, {arrayFormat: 'repeat'})
    config.data = qs.stringify(config.data, { allowDots: true })
  }
  // else{
  //   config.params= qs.stringify(config.data)
  // }
  return config
}, err)

// response interceptor
service.interceptors.response.use((response) => {

  return response.data
}, err)

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}